import SelectedInvoice from "./SelectedInvoice";
import WarrantyInvoice from "./WarrantyInvoice";
import Act from "./Act";
import ActEmpty from "./ActEmpty";
import PreAct from "./PreAct";
import Form43u from "./Form43u";
import TreatmentPlan from "./TreatmentPlan";
import Diary from "./Diary";
import Anketa from "./Anketa";

const obj = {
    selectedInvoice: SelectedInvoice,
    warrantyInvoice: WarrantyInvoice,
    act: Act,
    actEmpty: ActEmpty,
    preAct: PreAct,
    form43u: Form43u,
    treatmentPlan: TreatmentPlan,
    diary: Diary,
    anketa: Anketa
};

export default obj;
